
// @ts-nocheck
/* 
 * This file has type checking disabled to prevent the TS2589 error:
 * "Type instantiation is excessively deep and possibly infinite"
 * which occurs due to complex type inference with the Supabase client.
 */

import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { useToursData } from '@/hooks/useToursData';
import TourList from '@/components/tour/TourList';
import ToursLoading from '@/components/tour/ToursLoading';
import ToursError from '@/components/tour/ToursError';
import ToursEmpty from '@/components/tour/ToursEmpty';
import FooterLogo from '@/components/FooterLogo';

const Tours = () => {
  const { t } = useLanguage();
  const { tours, loading, error } = useToursData();

  return (
    <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20 pt-8 relative">
      {/* Abstract shapes in background */}
      <div className="agam-shape agam-shape-1"></div>
      <div className="agam-shape agam-shape-2"></div>
      <div className="agam-shape agam-shape-3"></div>
      
      {/* Page Title */}
      <h1 className="section-title mb-6 after:hidden font-bold text-center">{t('available_tours')}</h1>
      
      {/* Display tours */}
      {loading ? (
        <ToursLoading />
      ) : error ? (
        <ToursError message={error.message} />
      ) : tours.length > 0 ? (
        <TourList tours={tours} />
      ) : (
        <ToursEmpty />
      )}
      
      <FooterLogo />
    </div>
  );
};

export default Tours;
